import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import { fetchWorkEntriesProjectTracking } from "../../../../../store/slices/workentriesSlice";
import { fetchDescriptionTasksProjectTracking } from "../../../../../store/slices/DescriptionTask";
import { fetchHardwareDescriptions } from "../../../../../store/slices/hardwareDescriptionSlice";
import { cancelPersonFromProjectAssign } from "../../../../../store/slices/cancelPersonFromProjectSlice";
import { projectReviewOpAction } from "../../../../../store/slices/SalesProjectAssignSlices/projectAssignedAction";
import { reAssignProjectToOP } from "../../../../../store/slices/managerProjectAssign";
import { sendTrackingActionEmail } from "../../../../../store/slices/isTrackingActionSlice";

const AssignOPAction = ({ index, row, emp, setIsLoading, isViewOnly = false }) => {
      const dispatch = useDispatch();
      const { enqueueSnackbar } = useSnackbar();
      const [selectedOption, setSelectedOption] = useState("")
      const [openMenuIdx, setOpenMenuIdx] = useState(null); // null = no menu open
      const wrapperRef = useRef(null);
    
      useEffect(() => {
        function handleClickOutside(event) {
          if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setOpenMenuIdx(null);
          }
        }
        document.addEventListener("mousedown", handleClickOutside); // 👈 change "click" to "mousedown"
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, []);
    
      const handleActionSubmit = async (action) => {
        if (isViewOnly) return;
        const payload = {
          projectId: row._id,
          userId: emp._id,
          action: action,
        };
        setIsLoading(true);
        try {
            await dispatch(sendTrackingActionEmail(payload));
    
          enqueueSnackbar(
            `Task ${action === "complete" ? "Completed" : action.charAt(0).toUpperCase() + action.slice(1)}`,
            {
              variant: "success",
            }
          );
          dispatch(fetchAllProjects());
          setIsLoading(false);
        } catch {
          enqueueSnackbar(
            `Failed To ${action.charAt(0).toUpperCase()}${action.slice(
              1
            )} Task Details`,
            {
              variant: "error",
            }
          );
          setIsLoading(false);
        } finally {
          setIsLoading(false);
        }
      };
    
    
      const handleReAssignSubmit = async (emp) => {
        if (isViewOnly) return;
        const payload = {
          projectId: row._id,
          userId: emp._id,
        };
        setIsLoading(true);
        try {
            await dispatch(reAssignProjectToOP(payload));
          enqueueSnackbar(
            `Project Reassigned Successfully`,
            {
              variant: "success",
            }
          );
          dispatch(fetchAllProjects());
          setIsLoading(false);
        } catch {
          enqueueSnackbar(
            `Failed To Reassign Project`,
            {
              variant: "error",
            }
          );
          setIsLoading(false);
        } finally {
          setIsLoading(false);
        }
      };
    
      const handleOperationReviewAction = async (row, emp) => {
        if (isViewOnly) return;
        const payload = {
          projectId: row._id,
          userId: emp._id,
        };
        setIsLoading(true);
    
        try {
            await dispatch(projectReviewOpAction({ payload }));
          enqueueSnackbar(
            `Project Sent To Review`,
            {
              variant: "success",
            }
          );
          dispatch(fetchAllProjects());
          setIsLoading(false);
        } catch {
          enqueueSnackbar(
            `Failed To Sent Project To Review`,
            {
              variant: "error",
            }
          );
          setIsLoading(false);
        } finally {
          setIsLoading(false);
        }
      };
    
    
      const HandleCancelEmp = async (row, emp) => {
        if (isViewOnly) return;
        const projectid = row?._id;
        const personid = emp?._id;
        setIsLoading(true);
        try {
            await dispatch(cancelPersonFromProjectAssign({ projectid, personid }));
          enqueueSnackbar("Person Cancelled Successfully", {
            variant: "success",
          });
        } catch (error) {
          console.error("Failed to create task:", error);
        } finally {
          setIsLoading(false);
        }
        dispatch(fetchAllProjects());
        dispatch(fetchWorkEntriesProjectTracking());
        dispatch(fetchDescriptionTasksProjectTracking());
        dispatch(fetchHardwareDescriptions())
      };
  return (
      <div>
          <div className="w-full flex justify-center align-middle items-center ">
              {
                  // emp?.Assignedperson?.operationaction === "complete" ||
                  (
                      // emp?.customRole?.includes("project manager") &&
                      emp?.Assignedperson?.manageraction === "complete") ? (
                      <>
                          <div className="w-full h-full flex justify-center items-center">
                              <button className="cursor-default py-2 px-4 text-orange-600 border rounded-md bg-gray-100">
                                  Completed
                              </button>
                          </div>
                      </>
                  ) : (
                      <div className=" bg-white m-auto">
                          <div
                              ref={wrapperRef}
                              className="relative flex p-0 rounded-xl align-middle items-center"
                          >
                              <button
                                  disabled={isViewOnly || (emp?.Assignedperson?.projecttracktaskStatus !== "submit" &&
                                      emp?.customRole?.includes("project manager"))}
                                  type="button"
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      if (isViewOnly) return;
                                      setOpenMenuIdx(openMenuIdx === index ? null : index);
                                  }}
                                  className={`relative w-20 border text-[12px] border-gray-400 rounded-md p-2 shadow-md text-start overflow-hidden outline-none
    ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : (emp?.Assignedperson?.projecttracktaskStatus !== "submit" &&
                                          emp?.customRole?.includes("project manager") ? "opacity-50 cursor-not-allowed" : "")}`}
                              >
                                  {selectedOption || "Select"}
                                  <ExpandMoreIcon className="absolute top-1 right-0 bg-white" />
                              </button>

                              {openMenuIdx === index && (
                                  <div
                                      style={{ zIndex: 9999 }}
                                      className="absolute top-full left-0 w-full p-1 bg-white text-xs border border-gray-300 shadow-lg flex flex-col gap-1"
                                  >
                                      {emp?.Assignedperson?.operationaction !== "reject" && (
                                          <>
                                              {emp?.Assignedperson?.projecttracktaskStatus === "pending" &&
                                                  emp?.customRole?.includes("operations") && (
                                                      <div
                                                          className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                                                          onClick={() => {
                                                              setOpenMenuIdx(null);
                                                              handleActionSubmit("reminder");
                                                              setSelectedOption("Remind")
                                                          }}
                                                      >
                                                          Reminder
                                                      </div>
                                                  )}
                                          </>
                                      )}

                                      <>
                                          {emp?.Assignedperson?.projecttracktaskStatus === "submit" &&
                                              emp?.customRole?.includes("operations") && (
                                                  <div
                                                      className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                                                      onClick={() => {
                                                          setOpenMenuIdx(null);
                                                          handleOperationReviewAction(row, emp);
                                                          setSelectedOption("Review")
                                                      }}
                                                  >
                                                      Review
                                                  </div>
                                              )}
                                      </>

                                      {emp?.Assignedperson?.projecttracktaskStatus === "submit" && emp?.customRole?.includes("operations") && (
                                          <div
                                              className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                                              onClick={() => {
                                                  setOpenMenuIdx(null);
                                                  handleActionSubmit("complete");
                                                  setSelectedOption("Complete")
                                              }}
                                          >
                                              Complete
                                          </div>
                                      )}

                                      {emp?.Assignedperson?.projecttracktaskStatus === "submit" &&
                                          emp?.customRole?.includes("project manager") && (
                                              <div
                                                  className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                                                  onClick={() => {
                                                      setOpenMenuIdx(null);
                                                      handleActionSubmit("complete");
                                                      setSelectedOption("Complete")
                                                  }}
                                              >
                                                  Complete
                                              </div>
                                          )}

                                      {emp?.Assignedperson?.operationaction === "reject" && (
                                          <div
                                              className="p-1 hover:bg-gray-200 text-start cursor-pointer "
                                              onClick={() => {
                                                  handleReAssignSubmit(emp);
                                                  setOpenMenuIdx(null);
                                              }}
                                          >
                                              Re-assign
                                          </div>
                                      )}

                                      {emp?.customRole?.includes("operations") && (
                                          <div
                                              className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                                              onClick={() => {
                                                  setOpenMenuIdx(null);
                                                  // handleActionSubmit("cancel");
                                                  // setSelectedOption("Cancel")
                                                  HandleCancelEmp(row, emp)
                                              }}
                                          >
                                              Cancel
                                          </div>
                                      )}
                                  </div>
                              )}
                          </div>
                      </div>
                  )}
          </div>
      </div>  )
}

export default AssignOPAction